import React, { FC, useContext } from 'react';

import EditorSearchIcon from '@atlaskit/icon/glyph/editor/search';
import SelectClearIcon from '@atlaskit/icon/glyph/select-clear';

import { StorageOfUniqueServices } from '@qality/common-service';
import { QAlitySettingsContext } from '@qality/common-state/src/QAlitySettingsProvider/QAlitySettingsContext';
import { Utils } from '@qality/common-utils';

import {
  ClickableIconStyled,
  IconStyled,
} from './ProjectSettingsHeader.styled';
import { ProjectSettingsHeaderView } from './ProjectSettingsHeader.view';

export const ProjectSettingsHeader: FC = () => {
  const { query, onFilterChange, clearFilter } = useContext(
    QAlitySettingsContext
  );
  const uniqueMessages = StorageOfUniqueServices.get('uniqueMessages');

  const elementAfter = Utils.isNilOrEmpty(query) ? (
    <IconStyled>
      <EditorSearchIcon label='' />
    </IconStyled>
  ) : (
    <ClickableIconStyled onClick={clearFilter}>
      <SelectClearIcon label='' />
    </ClickableIconStyled>
  );

  return (
    <ProjectSettingsHeaderView
      title={uniqueMessages['page.settings.section.title']}
      subtitle={uniqueMessages['page.settings.section.subtitle']}
      linkName='Learn more about projects’ settings.'
      linkUrl='https://soldevelo.atlassian.net/wiki/spaces/QS/pages/2004844549/Settings'
      query={query}
      elementAfter={elementAfter}
      onFilterChange={onFilterChange}
    />
  );
};
